module.exports = __webpack_public_path__ + "img/moedas.0a8c3da3.svg";